import * as React from "react";
const SvgChevronRight = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M7.5 15L12.5 10L7.5 5", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgChevronRight;
